import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { PaperworkEntryList, PaperworkEntryFilter } from 'modules/paperwork-entry';

@inject(rootStore => ({
    paperworkEntryStore: rootStore.paperworkEntryStore,
    routerStore: rootStore.routerStore
}))
@observer
class PaperworkEntryListPage extends React.Component {
    constructor(props) {
        super(props);

        this.onPageChange = this.onPageChange.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.onChecboxChange = this.onChecboxChange.bind(this);
        this.handlePrintButtonClick = this.handlePrintButtonClick.bind(this);
        this.renderPrintButton = this.renderPrintButton.bind(this);
    }

    async componentDidMount() {
        this.props.paperworkEntryStore.clear();
        await this.props.paperworkEntryStore.getPaperworkStatuses(true);
    }

    async handleRefresh() {
        this.props.paperworkEntryStore.clear();
    }

    async handlePrintButtonClick() {
        const { routerStore } = this.props;
        routerStore.replace('/print');
    }

    onChecboxChange(event, item) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.props.paperworkEntryStore.selectEntryForPrint(item.id, value);
      }

      renderPrintButton(selectedCount) {
        const { loading } = this.props.paperworkEntryStore;
          if(selectedCount > 0)
          {
            return <button className="push btn btn--med btn--primary" disabled={loading} onClick={this.handlePrintButtonClick}>
                Print
            </button>
          }
      } 

    render() {
        const {
            entries,
            loading,
            filter,
            totalRecordCount,
            selectedForPrint,
            paperworkStatusLookup
        } = this.props.paperworkEntryStore;
        return (
            <div>
                <div className="clear">
                    <h3 className="pull type--medium">Paperwork entries</h3>
                    <button className="push btn btn--med btn--primary btn--refresh has-icon spc--left--tny" disabled={loading} onClick={this.handleRefresh}>
                        Refresh
                    </button>
                    {this.renderPrintButton(selectedForPrint.length)}
                </div>
                <div>
                <div>
                    <PaperworkEntryFilter
                    paperworkStatusLookup={paperworkStatusLookup}
                    />
                </div>
            </div>    
                <div className="separator--primary spc--bottom--sml spc--top--sml"></div>
                <PaperworkEntryList loading={loading}
                    items={entries}
                    pageNumber={filter.pageNumber}
                    pageSize={10}
                    totalRecordCount={totalRecordCount}
                    onPageChange={this.onPageChange}
                    onChecboxChange={this.onChecboxChange}
                />
            </div>
        )
    }

    onPageChange(page) {
        const { paperworkEntryStore } = this.props;
        paperworkEntryStore.setPage(page.selected + 1);
    }
}

export { PaperworkEntryListPage }


// WEBPACK FOOTER //
// ./src/pages/PaperworkEntryListPage.js